import { Component, OnInit } from "@angular/core";

@Component({
  selector: "icon-chat",
  templateUrl: "./chat.component.html",
  styleUrls: ["./chat.component.scss"],
})
export class ChatComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
